import fetch from "auth/FetchInterceptor";

export const ProductCategoryService = {};

ProductCategoryService.get = async ({
  page,
  pageSize,
  sort,
  searchText,
  state = null,
}) => {
  let apiUrl = "/v1/category?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Dname";
  else if (sort === "descend") apiUrl += "&order_by=%2Bname";
  if (searchText) apiUrl += "&name=" + searchText;
  if (state) {
    apiUrl += "&state=" + state;
  }
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

ProductCategoryService.getSelect = async () => {
  let apiUrl = "/v1/category";
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

ProductCategoryService.getById = async (id) => {
  const apiUrl = `/v1/category/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

ProductCategoryService.createCategory = async (data) => {
  const apiUrl = `/v1/category`;
  return fetch({
    url: apiUrl,
    method: "post",
    data: data,
  });
};

ProductCategoryService.updateCategory = async (data) => {
  const apiUrl = `/v1/category/${data.id}`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

ProductCategoryService.deleteCategory = async (id, confirm = false) => {
  let apiUrl = `/v1/category/${id}`;
  if (confirm) apiUrl = `/v1/category/${id}?confirmed`;
  return fetch({
    url: apiUrl,
    method: "delete",
  });
};

export default ProductCategoryService;
